/* NLB Quick-view sold-out patch - works alongside Wokiee's quick-view (does not rename existing functions) */
(function() {
  'use strict';
  var productCache = {};
  var QV = '#ModalquickView';

  function qvRoot() { return document.querySelector(QV); }

  function getProductHandle() {
    var link = document.querySelector(QV + ' .viewfullinfo');
    if (link) {
      var href = link.getAttribute('href') || '';
      var m = href.match(/\/products\/([^?#]+)/);
      if (m && m[1]) return decodeURIComponent(m[1]);
    }
    return null;
  }

  function fetchProduct(handle, cb) {
    if (!handle) return;
    if (productCache[handle]) { cb(productCache[handle]); return; }
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/products/' + handle + '.js');
    xhr.onload = function() {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          var p = JSON.parse(xhr.responseText);
          productCache[handle] = p;
          cb(p);
        } catch (e) {}
      }
    };
    xhr.send();
  }

  function selectedVariantId() {
    var input = document.querySelector(QV + ' #modal_quick_view .input_variant');
    return input ? String(input.value) : null;
  }

  function priceEl() { return document.querySelector(QV + ' .tt-product-single-info .tt-price'); }
  function addBtn() { return document.querySelector(QV + ' #modal_quick_view .btn-addtocart'); }

  function updateSoldOutState() {
    var handle = getProductHandle();
    if (!handle) return;
    fetchProduct(handle, function(product) {
      var vid = selectedVariantId();
      var variant = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(vid)) { variant = product.variants[i]; break; }
      }
      var price = priceEl();
      var btn = addBtn();
      var soldOut = !variant || !variant.available;
      if (soldOut) {
        if (price && !price.getAttribute('data-nlb-orig')) {
          price.setAttribute('data-nlb-orig', price.innerHTML);
        }
        if (price) price.innerHTML = '<span class="nlb-qv-soldout">SOLD OUT</span>';
        if (btn) { btn.classList.add('nlb-qv-disabled'); btn.setAttribute('disabled', 'disabled'); }
      } else {
        if (price && price.getAttribute('data-nlb-orig')) {
          price.innerHTML = price.getAttribute('data-nlb-orig');
          price.removeAttribute('data-nlb-orig');
        }
        if (btn) { btn.classList.remove('nlb-qv-disabled'); btn.removeAttribute('disabled'); }
      }
    });
  }

  function markSoldOutSizes() {
    var handle = getProductHandle();
    if (!handle) return;
    fetchProduct(handle, function(product) {
      var sizeIdx = 0;
      for (var i = 0; i < product.options.length; i++) {
        if (String(product.options[i].name || '').toLowerCase() === 'size') { sizeIdx = i; break; }
      }
      var key = 'option' + (sizeIdx + 1);
      var links = document.querySelectorAll(QV + ' .tt-options-swatch a[data-value]');
      for (var j = 0; j < links.length; j++) {
        var val = links[j].getAttribute('data-value');
        var ok = false;
        for (var k = 0; k < product.variants.length; k++) {
          var v = product.variants[k];
          if (v[key] === val && v.available) { ok = true; break; }
        }
        var li = links[j].closest ? links[j].closest('li') : links[j].parentNode;
        if (li) {
          if (!ok) li.classList.add('nlb-opt-soldout');
          else li.classList.remove('nlb-opt-soldout');
        }
      }
    });
  }

  function refresh() {
    var root = qvRoot();
    if (!root || !root.querySelector('.tt-product-single-info')) return;
    markSoldOutSizes();
    updateSoldOutState();
  }

  function init() {
    var root = qvRoot();
    if (!root) return;
    var obs = new MutationObserver(function() { refresh(); });
    obs.observe(root, { childList: true, subtree: true });
    document.addEventListener('click', function(e) {
      var t = e.target && e.target.closest ? e.target.closest(QV + ' .tt-options-swatch a[data-value]') : null;
      if (t) { setTimeout(updateSoldOutState, 60); }
    });
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();